import HolidayService from '../../../common/service/holidayService';

const MENU_API = '/landing/menu';

const getMenu = () => HolidayService.post(MENU_API);

export { getMenu };
